
    // Create a class for the element
class JsVariantPicker extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        this.init();
    }
    init(){
        this.optionDisplayTriggers = this.querySelectorAll('[optionDisplayTrigger]');
        this.optionDisplay = this.querySelector('[optionDisplay]');
        if(!!this.optionDisplay && !!this.optionDisplayTriggers){
            this.optionDisplayTriggers.forEach((trigger)=>{
                trigger.addEventListener('click', this.toggleOptionDisplay.bind(this));
                trigger.onclick = (e)=>{
                    (this.toggleOptionDisplay)
                }
            })
        }
        this.atcTriggers = this.querySelectorAll('[optionValue]');
        this.atcTriggers.forEach((trigger)=>{
            //ATC
            const atcVariantID = trigger.getAttribute('variantID');
            if(!!atcVariantID){
                const sectionsToUpdate = ['page-header', 'cart-drawer'].map((sel) => document.querySelector(sel)).filter((el) => el);
                const sectionIds = sectionsToUpdate.map((el) => el.dataset.sectionId);
                trigger.onclick = (e)=>{
                    //do nothing if atc variant is disabled
                    if(trigger.hasAttribute('disabled')){
                        return;
                    };
                    //close option display
                    this.toggleOptionDisplay();
                    //close modal
                    const modal = this.closest('[shop_the_look__modal]');
                    if(modal){
                        modal.setAttribute('hidden_mobile', '');
                    }
                    const itemsObject = {};
                    itemsObject['id'] = atcVariantID;
                    //qty plus one
                    itemsObject['quantity'] = 1;
                    const formData = {};
                    formData['items'] = [itemsObject];
                    //visual updates
                    formData['sections_url'] = window.location.pathname;             
                    formData['sections'] = sectionIds.join(',');             
                    fetch(window.Shopify.routes.root + 'cart/add.js', {
                        method: 'POST',
                        headers: {
                          'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(formData)
                    })
                    .then(async response => await response.json())
                    .then(data =>{
                    //adaptaion of ProductForm (main.js)
                    if (document.querySelector('.template-cart')) {
                        // Cart page
                        const cartForm = document.querySelector('cart-form');
                        if (cartForm && cartForm.enableAjaxUpdate) {
                            cartForm.refresh();
                        }
                        } else if (theme.settings.afterAddToCart === 'page') {
                        // Allow the tick animation to complete
                        setTimeout(() => {
                            window.location.href = theme.routes.cart;
                        }, 300);
                        } else {
                            if (data.sections && sectionsToUpdate.length === Object.keys(data.sections).length) {
                                sectionsToUpdate.forEach((el) => {
                                el.updateFromCartChange(data.sections[el.dataset.sectionId]);
                                });
                            } else {
                                // Unexpected null section return has been observed
                                this.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));
                            }
                            if (theme.settings.afterAddToCart === 'notification') {
                                const notification = document.getElementById('BISAddedNotification').content.firstElementChild.cloneNode(true);
                                if(!!data && !!data.items){
                                    notification.dataset.productTitle = data?.items[0]?.product_title ? data.items[0].product_title : 'Product';
                                }
                                let notificationContainer = document.querySelector('.pageheader--sticky');
                                if (!notificationContainer) {
                                    notificationContainer = document.querySelector('body');
                                }
                                notificationContainer.appendChild(notification);
                            } else if (theme.settings.afterAddToCart === 'drawer') {
                                document.querySelector('.js-cart-drawer').open();
                            }
                        }
                    })
                    .catch((error) => {
                        console.error('Error:', error);
                    });
                }
            }
        })
    }
    toggleOptionDisplay(){
        this.optionDisplay.toggleAttribute('hidden');
        if(this.optionDisplay.hasAttribute('hidden')){
            this.removeAttribute('active');
        }else{
            const activeVariantPickers = document.querySelectorAll('js-variant-picker[active]');
            activeVariantPickers.forEach((activePicker)=>{
                activePicker.removeAttribute('active');
                const optionDisplay = activePicker.querySelector('[optiondisplay]');
                if(!!optionDisplay){
                    optionDisplay.setAttribute('hidden', '')
                }
            })
            this.setAttribute('active', '');

        }
    }
}
customElements.define("js-variant-picker", JsVariantPicker);


// klaviyo bis trigger
function openVariantSelectKlaviyoBISPopup(event){
const fakeKlaviyoBISPopup = document.querySelector('#fake-KlaviyoBISPopup');
if(fakeKlaviyoBISPopup){
    //event to close other open modals
    document.dispatchEvent(new Event('klavioBIS:open'));
    //create and call functions to close shop the look modal
    const title = fakeKlaviyoBISPopup.querySelector('.modal-title');
    const variantSelector = fakeKlaviyoBISPopup.querySelector('#bis_variants');
    const clickedVariant = event.target.parentElement;
    const allVariantsWrapper = event.target.closest('.quickbuy-options');
    if(title && variantSelector && clickedVariant && allVariantsWrapper){
        let title_value = clickedVariant.getAttribute('data-item-title');
        let not_available_variants = allVariantsWrapper.querySelectorAll('.variant[data-variant-available="false"]');
        let current_variant = clickedVariant.getAttribute('data-variant-title');
        title.innerHTML = title_value;
        variantSelector.innerHTML = '';
        not_available_variants.forEach((variant)=>{
            if(variant.getAttribute('data-variant-title') == current_variant){
                variantSelector.innerHTML += `<option value="${variant.getAttribute('data-variant-id')}" selected>${variant.getAttribute('data-variant-title')}</option>`;
            }else{
                variantSelector.innerHTML += `<option value="${variant.getAttribute('data-variant-id')}">${variant.getAttribute('data-variant-title')}</option>`;
            }
        });
        const completed_message = fakeKlaviyoBISPopup.querySelector('#completed_message');
        const error_message = fakeKlaviyoBISPopup.querySelector('#error_message');
        if(completed_message && error_message){
            completed_message.classList.add('hidden');
            error_message.classList.add('hidden');
        }
        const email_message = fakeKlaviyoBISPopup.querySelector('#bis_no_email');
        const submit_btn = fakeKlaviyoBISPopup.querySelector('#js_vs_bis_submit_btn');
        const email_input = fakeKlaviyoBISPopup.querySelector('#bis_email');
        if(email_message && submit_btn && email_input){
            email_input.value = '';
            email_input.removeAttribute('disabled');
            email_message.classList.remove('hidden');
            submit_btn.setAttribute('disabled', 'disabled');
            submit_btn.classList.remove('hidden');
        }
    }
    fakeKlaviyoBISPopup.classList.remove('hidden');
}
}
function exitFakeKlaviyoBISPopup(){
    const fakeKlaviyoBISPopup = document.querySelector('#fake-KlaviyoBISPopup');
    if(fakeKlaviyoBISPopup){
        fakeKlaviyoBISPopup.classList.add('hidden');
    }
}
function submitFakeKlaviyoBISPopup(){
    const fakeKlaviyoBISPopup = document.querySelector('#fake-KlaviyoBISPopup');
    if(fakeKlaviyoBISPopup){
        event.preventDefault();

        const emailInput = document.getElementById('bis_email');
        const variantInput = document.getElementById('bis_variants');
        if (!emailInput || !variantInput) {
            console.error('Required elements are missing in the DOM.');
            return;
        }

        const email = emailInput.value;
        const variantId = `$shopify:::$default:::${variantInput.value}`;

        const payload = {
            "data": {
                "type": "back-in-stock-subscription",
                "attributes": {
                    "profile": {
                        "data": {
                            "type": "profile",
                            "attributes": {
                                "email": email
                            }
                        }
                    },
                    "channels": ["EMAIL"]
                },
                "relationships": {
                    "variant": {
                        "data": {
                            "type": "catalog-variant",
                            "id": variantId
                        }
                    }
                }
            }
        };

        fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=QVtrDX`, {
            method: 'POST',
            headers: {
                "Content-Type": "application/json",
                "revision": "2024-06-15"
            },
            body: JSON.stringify(payload),
        })
        .then(response => {
            if (response.ok) {
                //show completed_message
                const completed_message = fakeKlaviyoBISPopup.querySelector('#completed_message');
                const email_message = fakeKlaviyoBISPopup.querySelector('#bis_no_email');
                const submit_btn = fakeKlaviyoBISPopup.querySelector('#js_vs_bis_submit_btn');
                const email_input = fakeKlaviyoBISPopup.querySelector('#bis_email');
                if(email_message && submit_btn && email_input && completed_message){
                    email_input.setAttribute('disabled', 'disabled');
                    email_message.classList.add('hidden');
                    submit_btn.setAttribute('disabled', 'disabled');
                    submit_btn.classList.add('hidden');
                    completed_message.classList.remove('hidden');
                }
            } else {
                //show error_message
                const error_message = fakeKlaviyoBISPopup.querySelector('#error_message');
                const email_message = fakeKlaviyoBISPopup.querySelector('#no_email');
                const submit_btn = fakeKlaviyoBISPopup.querySelector('#js_vs_bis_submit_btn');
                const email_input = fakeKlaviyoBISPopup.querySelector('#bis_email');
                if(email_message && submit_btn && email_input && error_message){
                    email_input.setAttribute('disabled', 'disabled');
                    email_message.classList.add('hidden');
                    submit_btn.setAttribute('disabled', 'disabled');
                    submit_btn.classList.add('hidden');
                    error_message.classList.remove('hidden');
                }
                response.json().then(data => console.error('Subscription failed:', data));
            }
        })
        .catch(error => console.error('Error:', error));
    }
}

//If no email value, bis_submit_btn disabled, else enabled
document.getElementById('bis_email').addEventListener('input', function(event) {
const submitBtn = document.getElementById('js_vs_bis_submit_btn');
const noEmailMessage = document.getElementById('bis_no_email');
if(submitBtn && noEmailMessage){
    const email = event.target.value;
    if (email) {
        submitBtn.removeAttribute('disabled');
    } else {
        submitBtn.setAttribute('disabled', 'disabled');
    }
    noEmailMessage.classList.toggle('hidden', !!email);
}
});